








import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import DoorFamilyList from './DoorFamilyList.vue';
import ProductFilter from './ProductFilter.vue';
import { Product } from '@/models/Product';

@Component({
    components: {
        DoorFamilyList,
        ProductFilter
    }
})
export default class DoorFamilyCategory extends Vue {
    protected categories: any[];

    constructor() {
        super();

        this.categories = JSON.parse(this.$attrs['data-items']);
        //console.log('this.categories', this.categories);
        this.$attrs['data-items'] = '';
    }
}
